var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"u-mt-10",attrs:{"data":"basket-summary-checkout-button"}},[_c('div',{staticClass:"u-w-full"},[_c('lp-button',{staticClass:"u-w-full u-block u-text-center",attrs:{"spinner":_vm.showSpinnerOnButton}},[_vm._v("\n            "+_vm._s(_vm.buttonText)+"\n        ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }